import { Button, Card, Dropdown, Layout, Select } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const DateText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.settings.tertiary};
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const GreetingText = styled.div`
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.inter};
  color: ${({ theme }) => theme.settings.tertiary};
`;

export const SubGreetingText = styled.div`
  font-size: 24px;
  line-height: 30px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.inter};
  background: linear-gradient(
    270deg,
    #fdc716 0%,
    #fc695b 26.44%,
    #f94f69 50%,
    #e13181 75%,
    #af4bcc 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;
// Summary Cards
export const SummaryCard = styled(Card)`
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
  height: 100%;
  min-height: 280px;
  svg,
  path,
  focus,
  focus-visible,
  .recharts-layer {
    outline: none !important;
    border: none !important;
  }
  .ant-card-head {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    color: ${({ theme }) => theme.settings.tertiary};
    border-bottom: none;
    padding-top: 10px;
    min-height: 40px;
  }
  &.small {
    min-height: 100%;
    padding: 4px;
  }
  .ant-card-body {
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .pieChartWrapper {
    position: relative;
    height: 220px;
    font-family: ${({ theme }) => theme.fonts.inter};
    .recharts-tooltip-wrapper {
      z-index: 9999 !important;
    }
    .totalValue {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      pointer-events: none;
      span {
        font-size: 16px;
        line-height: 16px;
        font-weight: 400;
        color: ${({ theme }) => theme.settings.tertiary};
      }
      span.number {
        font-size: 24px;
        line-height: 24px;
        font-weight: 600;
        color: ${({ theme }) => theme.settings.tertiary};
      }
    }
  }
  .legendWrapper {
    display: flex;
    justify-content: start;
    gap: 16 !important;
    margin-top: 15px;
    padding: 0px 24px;
    flex-wrap: wrap;
    .legendItems {
      display: flex;
      align-items: center;
      margin: 0px 10px 10px 0px;
      font-size: 10px;
      color: ${({ theme }) => theme.settings.textColor};
    }
    span.legendSquare {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 4px;
      &.color1 {
        background-color: #14b8a6;
      }
      &.color2 {
        background-color: #8b5cf6;
      }
      &.color3 {
        background-color: #ec4899;
      }
    }
  }
  .smallCard {
    position: relative;
    width: 100%;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    .smallCardTitle {
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      color: ${({ theme }) => theme.settings.tertiary};
      min-height: 36px;
      @media (max-width: 768px) {
        min-height: auto;
      }
    }
    .smallCardDescription {
      font-size: 18px;
      font-weight: 700;
      line-height: 18px;
      color: ${({ theme }) => theme.settings.tertiary};
    }
  }
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow:
      0px 12px 40px rgba(89, 108, 148, 0.15),
      0px 4px 12px rgba(89, 108, 148, 0.08),
      0px 0px 0px 1px rgba(89, 108, 148, 0.1);
  }
`;

// Chart Cards
export const ChartCard = styled(Card)`
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
  height: 280px;
  svg,
  path,
  focus,
  focus-visible,
  .recharts-layer {
    outline: none !important;
    border: none !important;
  }
  .ant-card-head {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    color: ${({ theme }) => theme.settings.tertiary};
    border-bottom: none;
    padding-top: 10px;
    min-height: 40px;
    .ant-card-extra {
      .chartOldLegendWrapper {
        display: flex;
        justify-content: center;
        gap: 16px;
        margin-top: 4px;
        flex-wrap: wrap;
        .items {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          font-weight: 600;
          line-height: 14px;
          color: ${({ theme }) => theme.settings.textColor};
          .legendSquare {
            width: 12px;
            height: 12px;
            border-radius: 50%;
          }
        }
      }
    }
  }
  .ant-card-body {
    padding: 16px 0px 16px 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &.chartOldCard {
    .ant-card-body {
      padding: 0px 24px 24px 24px;
      .title {
        font-size: 26px;
        font-weight: 700;
        line-height: 26px;
        text-align: center;
        color: ${({ theme }) => theme.settings.tertiary};
        margin-top: 20px;
        text-align: center;
        span {
          line-height: 18px;
          font-size: 16px;
          font-weight: 500;
          color: ${({ theme }) => theme.settings.textColor};
        }
      }
      svg {
        margin: 0px auto;
      }
      .legendWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px !important;
        margin-top: 20px;
        .items {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          @media (max-width: 768px) {
            text-align: center;
          }
          .legendSquare {
            width: 30px;
            height: 15px;
            border-radius: 20px;
            @media (max-width: 768px) {
              width: 12px;
              height: 12px;
            }
            &.bgRed {
              background: #ed8181;
            }
            &.bgYellow {
              background: #e5c15d;
            }
            &.bgGreen {
              background: #409150;
            }
          }
          .text {
            font-size: 12px;
            font-weight: 600;
            line-height: 18px;
            color: ${({ theme }) => theme.settings.textColor};
          }
        }
      }
    }
  }
  .chartOldLegendWrapper {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 4px;
    flex-wrap: wrap;
    .items {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
      color: ${({ theme }) => theme.settings.textColor};
      .legendSquare {
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }
    }
  }
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow:
      0px 12px 40px rgba(89, 108, 148, 0.15),
      0px 4px 12px rgba(89, 108, 148, 0.08),
      0px 0px 0px 1px rgba(89, 108, 148, 0.1);
  }
`;

// Activity Cards
export const ActivityCard = styled(Card)`
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  position: relative;
  .ant-card-body {
    padding: 10px 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.primary};
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 8px;
    @media (max-width: 991.99px) {
      gap: 4px;
      align-self: start;
      padding: 8px !important;
      font-size: 14px;
      line-height: 20px;
      svg,
      img {
        height: 18px;
      }
    }
    span {
      font-weight: 700;
    }
    svg,
    img {
      margin-right: 2px;
      font-size: 20px;
      color: ${({ theme }) => theme.settings.primary};
      filter: ${({ theme }) => theme.settings.imgFilterColor};
    }
  }
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow:
      0px 12px 40px rgba(89, 108, 148, 0.15),
      0px 4px 12px rgba(89, 108, 148, 0.08),
      0px 0px 0px 1px rgba(89, 108, 148, 0.1);
  }
`;

// Heatmap Card
export const HeatmapCard = styled(Card)`
  font-family: ${({ theme }) => theme.fonts.inter};
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
  height: 100%;
  .ant-card-head {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.tertiary};
    border-bottom: none;
    padding-top: 10px;
    min-height: 40px;
  }
  .ant-card-body {
    padding: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .heatmapWrapper {
    display: grid;
    grid-template-columns: 110px 1fr 1fr 1fr 1fr;
    gap: 30px;
    margin-bottom: 24px;
    @media (max-width: 768px) {
      gap: 10px;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr !important;
    }
    .headerTitle {
      font-size: 12px;
      font-weight: 500;
      line-height: 14px;
      color: ${({ theme }) => theme.settings.tertiary};
      @media (max-width: 768px) {
        font-size: 10px;
      }
    }
  }
  .heatMapData {
    display: grid;
    grid-template-columns: 110px 1fr 1fr 1fr 1fr;
    gap: 30px;
    align-items: center;
    margin-bottom: 24px;
    @media (max-width: 768px) {
      gap: 6px;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr !important;
    }
    .titleText {
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      color: ${({ theme }) => theme.settings.textColor};
      @media (max-width: 768px) {
        font-size: 10px;
      }
    }
    .items {
      width: 100%;
      max-width: 80px;
      height: 24px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  &.quoteCard {
    .ant-card-body {
      padding: 16px 24px;
    }
    .quoteCardWrapper {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .quoteCardIcon {
        position: absolute;
        top: 18px;
        right: 24px;
      }
      .quoteCardContent {
        font-size: 16px;
        font-weight: 600;
        font-style: italic;
        color: ${({ theme }) => theme.settings.tertiary};
        line-height: 1.4;
        span {
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 34px;
          display: block;
          color: ${({ theme }) => theme.settings.textColor};
        }
      }
    }
    .subTitle {
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      color: ${({ theme }) => theme.settings.tertiary};
    }
    .quoteInsideWrapper {
      font-family: ${({ theme }) => theme.fonts.inter};
      display: flex;
      flex-direction: column;
      gap: 10px;
      .itemsWrapper {
        display: flex;
        align-items: start;
        justify-content: space-between;
        background-color: ${({ theme }) => theme.settings.bodyBg};
        border-radius: 10px;
        padding: 12px 16px;
        .itemsList {
          display: flex;
          align-items: start;
          gap: 8px;
          flex: 1;
          .quoteIcon {
            width: 20px;
            height: 20px;
            rotate: 180deg;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: transparent;
          }
          .quoteText {
            font-family: ${({ theme }) => theme.fonts.inter};
            font-style: italic;
            font-size: 12px;
            font-weight: 600;
            line-height: 18px;
            color: ${({ theme }) => theme.settings.tertiary};
            padding: 0px 6px;
          }
        }
      }
    }
  }
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow:
      0px 12px 40px rgba(89, 108, 148, 0.15),
      0px 4px 12px rgba(89, 108, 148, 0.08),
      0px 0px 0px 1px rgba(89, 108, 148, 0.1);
  }
`;

export const ActivityTitle = styled.h1`
  width: 100%;
  position: relative;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  margin: 0px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.settings.tertiary};
`;
